
export const spacing = {
  padding: 16
};